import React from "react";
import "../../css/pages/services.scss";
import servicesNumberImage from "../../assets/stats/doctor-patient.png";
import expImage from "../../assets/stats/examination.png";
import historyImage from "../../assets/stats/health-report.png";
import statsImage from "../../assets/stats/aaa.png";
import { Divider } from "@mui/material";

const ServiceCard = ({
  image,
  title,
  description,
}: {
  image: string;
  title: string;
  description: string;
}) => {
  return (
    <div className="serviceCard">
      <img src={image} alt={title} className="serviceImage" />
      <h2 className="serviceTitle">{title}</h2>
      <p className="serviceDescription">{description}</p>
    </div>
  );
};
const servicesData = [
  {
    title: "۱۰+ سال تجربه",
    description: "با بیش از 10 سال تجربه در ارائه خدمات فیزیوتراپی",
    image: expImage,
  },
  {
    title: "۸۰۰+ بیمار درمان شده",
    description: "بیش از ۸۰۰ بیمار با موفقیت درمان شده‌اند",
    image: historyImage,
  },
  {
    title: "ارایه ۴+ خدمات تخصصی",
    description: "ارائه بیش از ۴ خدمات تخصصی در زمینه فیزیوتراپی و کاردرمانی",
    image: servicesNumberImage,
  },
];
function Stats() {
  return (
    <div className="servicesWrapper ">
      <div className="servicesHeader">
        <Divider>
          <h1 className="servicesTitle">آمار گویای تجربه</h1>
        </Divider>
      </div>
      <div id="statsContainer" className="servicesContainer">
        <div id="statImage" className="servicesImage">
          <img src={statsImage} alt="Stats" />
        </div>
        <div id="statsContent" className="servicesContent">
          {servicesData.map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Stats;
